import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import "../assets/css/deposit.scss"

import RightSide from './RightSide';
import Footer from './Footer';

import fileNotFound from '../assets/img/file-not-found.svg';

class FileNotFound extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        const { t } = this.props;
        const { whitemarkTitle, whitemarkFavicon, whitemarkBackground, whitemarkLogo } = this.props;
        return (
            <div className="main">
                <Helmet>
                    <title>{whitemarkTitle}</title>
                    {<link rel="shortcut icon" href={whitemarkFavicon} />}
                    <style type="text/css">
                        {`
                            .main {
                                background: url(${whitemarkBackground});
                                background-size: cover;
                                background-attachment: fixed;
                            }

                            .main>div.darker{
                                background-color: rgba(32,32,48,0.7);
                                min-height: 100vh;
                            }

                            .logo {
                                background-image: url(${whitemarkLogo});
                            }
                        `}
                    </style>
                </Helmet>
                <div className={/*whitemarkTitle === "LockSelf Deposit Box" ? "darker" :*/ "noDark"}>
                    <div className="container-fluid mainNotFound">
                        <div className="NotFoundContainer">
                            <div className="header">
                                <div className="logo"></div>
                            </div>
                            <div className="body">

                                <div className="bigCard">
                                    <div className="Central">
                                        <div className="errorCard">
                                            <div>
                                                <span>{t("error.oops")}</span>
                                            </div>
                                            <h2>{t("error.fileNotFound")}</h2>
                                            <p>{t("error.msgErrorTransfer")}</p>
                                            <img className="center" src={fileNotFound} alt="logo" />
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                        <RightSide depositAvailable={false} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(FileNotFound)
